export const landmarksPoints = {
  type: "FeatureCollection",
  name: "landmarks_points",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        lat: 45.4241499,
        lng: 12.339452,
        name: "Villa Hériot",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 26,
        place_id: "ChIJ_f96P9WvfkcRoWkf-VJFbKc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33945, 45.42415] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.424886,
        lng: 12.3323713,
        name: "Church of the Santissimo Redentore",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 576,
        place_id: "ChIJL5LLXiuwfkcRyx4enzr3v2g",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33237, 45.42489] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4257344,
        lng: 12.3230778,
        name: "Chiesa dei Santi Cosma e Damiano",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 6,
        place_id: "ChIJIyFwOtWxfkcRZ6klsPfldzc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32308, 45.42573] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4255198,
        lng: 12.3309366,
        name: "Monastero delle Suore Clarisse",
        types: [
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJH5XvtyywfkcRPgztQI3pqsw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33094, 45.42552] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.425374,
        lng: 12.332094,
        name:
          "Stadtführungen venedig - Max Tessari Genehmigter Stadtführer in Venedig",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 3,
        place_id: "ChIJdQJ2qCywfkcRkp-_cfV9IdI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33209, 45.42537] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4254944,
        lng: 12.3603783,
        name:
          "Stadtführungen venedig - Max Tessari Genehmigter Stadtführer in Venedig",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJGX-rZymvfkcRqPpLu7Rj5OI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.36038, 45.42549] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4266468,
        lng: 12.3384477,
        name: "Casa dei Tre Oci, Venice",
        types: [
          "art_gallery",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 773,
        place_id: "ChIJh8FFaNWxfkcRWptF0jTejw4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33845, 45.42665] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4268969,
        lng: 12.3392009,
        name: "Le Zitelle",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.0,
        user_ratings_total: 56,
        place_id: "ChIJnTASnSqufkcRuQ_8MbLXj1U",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3392, 45.4269] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4274866,
        lng: 12.3218058,
        name: "Giudecca 795 Art Gallery",
        types: [
          "art_gallery",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.8,
        user_ratings_total: 29,
        place_id: "ChIJT9bqXMuxfkcR-mDXv6HEXrc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32181, 45.42749] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4271754,
        lng: 12.3657346,
        name: "Chiesa parrocchiale di Sant'Elena Imperatrice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 80,
        place_id: "ChIJ2_rhH0qufkcRFQsLB3VzCX0",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.36573, 45.42718] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4284137,
        lng: 12.3317409,
        name: "Chiesa dello Spirito Santo",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 15,
        place_id: "ChIJjfAVvs6xfkcRhMGxSqJsNGQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33174, 45.42841] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4285182,
        lng: 12.331495,
        name: "Casa di Gardella alle Zattere",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 15,
        place_id: "ChIJM2Wnp9OxfkcRp3g2gPFy2bs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3315, 45.42852] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.428765,
        lng: 12.342866,
        name: "Fondazione Giorgio Cini",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 502,
        place_id: "ChIJw7Z9KiqufkcRVXvzumEqeiA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34287, 45.42876] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4287722,
        lng: 12.3580806,
        name: "Giardini della Biennale",
        types: [
          "tourist_attraction",
          "park",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 6953,
        place_id: "ChIJqzZkRzGufkcRiabs3CYIiBk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.35808, 45.42877] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4295157,
        lng: 12.3273085,
        name: "Church of Santa Maria del Rosario (Gesuati)",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 288,
        place_id: "ChIJu75WbMyxfkcRg9WWq-II_4c",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32731, 45.42952] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4292365,
        lng: 12.3344745,
        name: "Fondazione Emilio e Annabianca Vedova",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 40,
        place_id: "ChIJb8D489OxfkcRraqsTvAhols",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33447, 45.42924] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4294192,
        lng: 12.343204,
        name: "Church of San Giorgio Maggiore",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 5515,
        place_id: "ChIJwwEk49exfkcRDVM3f6QBCJA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3432, 45.42942] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4302348,
        lng: 12.3242308,
        name: "V-A-C Zattere",
        types: [
          "museum",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 145,
        place_id: "ChIJRTAsRsyxfkcRGvericnydog",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32423, 45.43023] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4302885,
        lng: 12.3258824,
        name: "Squero di San Trovaso",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 132,
        place_id: "ChIJCc5DyM2xfkcRqJBesa_ACjs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32588, 45.43029] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.429935,
        lng: 12.32765,
        name: "Centro Culturale Don Orione Artigianelli",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 99,
        place_id: "ChIJ2e-8ic2xfkcR9VsThX2n0P0",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32765, 45.42994] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4306579,
        lng: 12.3303362,
        name: "St. George's Church",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 26,
        place_id: "ChIJ1f6lNdKxfkcRVwv193zs2g8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33034, 45.43066] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4302608,
        lng: 12.3310838,
        name: "Marazzi Loris",
        types: [
          "art_gallery",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.1,
        user_ratings_total: 17,
        place_id: "ChIJ0014LdKxfkcRCXT0BNY3au8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33108, 45.43026] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4305839,
        lng: 12.3354819,
        name: "Seminario Patriarcale di Venezia",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 6,
        place_id: "ChIJt1f70M2xfkcRLcOmWcHdwzQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33548, 45.43058] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4301618,
        lng: 12.3432211,
        name: "Faro San Giorgio Maggiore",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 24,
        place_id: "ChIJ26PwhSmufkcRtjkpQFLjG5k",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34322, 45.43016] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4304921,
        lng: 12.3571032,
        name: "Church of San Giuseppe di Castello",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 46,
        place_id: "ChIJ39uxGTGufkcRtMOrsl6pjXA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3571, 45.43049] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4313599,
        lng: 12.3232756,
        name: "Chiesa di Ognissanti",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.2,
        user_ratings_total: 10,
        place_id: "ChIJ_zbdBMyxfkcRXISXYk1EtHY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32328, 45.43136] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4309709,
        lng: 12.3308513,
        name: "Palazzo Da Mula Morosini",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 23,
        place_id: "ChIJi_t6J9KxfkcR36Ii3wa7s1Q",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33085, 45.43097] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4309657,
        lng: 12.3305516,
        name: "Palazzo Barbarigo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 4,
        place_id: "ChIJLe9lyWqxfkcRMd2Bo6jfkvs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33055, 45.43097] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4308424,
        lng: 12.3322393,
        name: "Palazzo Dario",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 57,
        place_id: "ChIJpU4mfdGxfkcRy3Huna_bzYQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33224, 45.43084] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.430675,
        lng: 12.3347626,
        name: "Basilica di Santa Maria della Salute",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 7451,
        place_id: "ChIJ241oDzOwfkcRXyfdym_t-ck",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33476, 45.43068] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4314603,
        lng: 12.3525968,
        name: "Giardino della Marinaressa",
        types: [
          "tourist_attraction",
          "park",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 685,
        place_id: "ChIJAy5F1S-ufkcReQqjg_LgAwo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3526, 45.43146] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.430718,
        lng: 12.3554559,
        name: "Serra dei Giardini Nonsoloverde Soc.Coop. Sociale Onlus",
        types: [
          "cafe",
          "tourist_attraction",
          "food",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.1,
        user_ratings_total: 56,
        place_id: "ChIJ7-9VGjCufkcRHajS4Pyelb8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.35546, 45.43072] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4320897,
        lng: 12.3111679,
        name: "Church of Santa Marta",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.2,
        user_ratings_total: 74,
        place_id: "ChIJwaz3DbSxfkcRCQ9jJ2t_AF4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31117, 45.43209] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4320049,
        lng: 12.3199577,
        name: "Church of Saint Sebastian",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 343,
        place_id: "ChIJfwNXbMOxfkcR97TkZm0Vj-c",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31996, 45.432] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4321067,
        lng: 12.329294,
        name: "Campo San Vidal",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.0,
        user_ratings_total: 2,
        place_id: "ChIJLUKA4MKxfkcR4_B3S-v9MsU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32929, 45.43211] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4316504,
        lng: 12.3289078,
        name: "Ponte dell'Accademia",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 7870,
        place_id: "ChIJjYs6_dGxfkcRJYlQcj3fDKk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32891, 45.43165] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.43185,
        lng: 12.3296411,
        name: "Palazzo Cavalli-Franchetti—cafeteria",
        types: [
          "art_gallery",
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 582,
        place_id: "ChIJZzWG5dGxfkcRACU5ucx4eIM",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32964, 45.43185] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.432004,
        lng: 12.329688,
        name: "Glasstress",
        types: [
          "art_gallery",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.8,
        user_ratings_total: 12,
        place_id: "ChIJpzSfG9KxfkcRAlQRyl14SNg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32969, 45.432] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4317068,
        lng: 12.3318022,
        name: "Palazzo Corner della Ca' Granda",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 39,
        place_id: "ChIJEQZJmtqxfkcRKenn3TaKLWw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3318, 45.43171] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4316798,
        lng: 12.3312957,
        name: "Casina delle Rose",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJMbaKkvSxfkcRgvjVa3TDjI4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3313, 45.43168] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4321147,
        lng: 12.3357931,
        name: "Palazzo Treves",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 23,
        place_id: "ChIJ7dAw0taxfkcRZnzOK83VkXc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33579, 45.43211] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4322462,
        lng: 12.3365716,
        name: "Ca' Giustinian",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 179,
        place_id: "ChIJ1VBjB8-xfkcRBNtfSOvBs6g",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33657, 45.43225] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4318571,
        lng: 12.3406262,
        name: "Bacino San Marco",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 71,
        place_id: "ChIJNylvLtaxfkcRALfxDa7UoJo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34063, 45.43186] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4319438,
        lng: 12.3509972,
        name: "Memorial plate, Home of John Cabot",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 76,
        place_id: "ChIJNfudpC-ufkcRy3hzAb0aNIM",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.351, 45.43194] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4319979,
        lng: 12.354877,
        name: "Giuseppe Garibaldi Monument",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 640,
        place_id: "ChIJCUYsFDCufkcRzMfU7CWTfbA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.35488, 45.432] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4330774,
        lng: 12.3192941,
        name: "Ariani Cicogna Palace",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.5,
        user_ratings_total: 19,
        place_id: "ChIJSbB5msmxfkcR46_Jm-vzRec",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31929, 45.43308] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4331698,
        lng: 12.3243702,
        name: "Ponte dei Pugni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 574,
        place_id: "ChIJT65lxM6xfkcRp7w0IzsWwno",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32437, 45.43317] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4330736,
        lng: 12.3254801,
        name: "Chiesa di San Barnaba",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 893,
        place_id: "ChIJh7nAwc6xfkcRFRkUct6EJTc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32548, 45.43307] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4331585,
        lng: 12.3279278,
        name: "Palazzo Malipiero",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 47,
        place_id: "ChIJfXfSSc6xfkcRPS4hOySZP_8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32793, 45.43316] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.433158,
        lng: 12.330021,
        name: "Canal Guachi",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJZ_uXYV-xfkcRWQPbfa5rAjs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33002, 45.43316] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4326481,
        lng: 12.330671,
        name: "Palazzo Morosini Gatterburg",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.7,
        user_ratings_total: 3,
        place_id: "ChIJF1fox9GxfkcRg7DYskG6ttU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33067, 45.43265] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4330741,
        lng: 12.3312283,
        name: "Gondola",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJRx9ajamxfkcRewgAb7cSkj4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33123, 45.43307] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4332965,
        lng: 12.3319652,
        name: "Santo Stefano Bell Tower",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 23,
        place_id: "ChIJoXT4UtCxfkcRMv1KB29dLlY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33197, 45.4333] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.433308,
        lng: 12.3333238,
        name: "Ponte Maria Callas",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJYXnK_NCxfkcRL5zWTM7qgHg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33332, 45.43331] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4331019,
        lng: 12.3360763,
        name: "San Moisè, Venice",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 621,
        place_id: "ChIJ19v8L9exfkcRsEmt1AW4bCw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33608, 45.4331] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4329839,
        lng: 12.3382915,
        name: "Royal Gardens",
        types: [
          "tourist_attraction",
          "park",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.2,
        user_ratings_total: 704,
        place_id: "ChIJMasuBtexfkcRJCxPSAYJlVY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33829, 45.43298] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4333075,
        lng: 12.3400769,
        name: "Place Riva Degli Schiavoni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 3,
        place_id: "ChIJcfZJRLOxfkcR5s33SRj6ZVU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34008, 45.43331] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4330969,
        lng: 12.3489178,
        name: "Forni Militari",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJM-anTE-vfkcREzNt-zwI2vI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34892, 45.4331] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4325096,
        lng: 12.3502557,
        name: "Chiesa di San Biagio Vescovo",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.2,
        user_ratings_total: 15,
        place_id: "ChIJQbRfci-ufkcRbTnCFMPVeqU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.35026, 45.43251] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4325085,
        lng: 12.3578369,
        name: "Chiesa di Sant'Anna",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.1,
        user_ratings_total: 23,
        place_id: "ChIJ_ZTFnDCufkcRU2RQgxQRB_Y",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.35784, 45.43251] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.434018,
        lng: 12.32168,
        name: "Palazzo Foscarini",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.7,
        user_ratings_total: 3,
        place_id: "ChIJnQ0dHMmxfkcR4MwKa6C217I",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32168, 45.43402] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4336557,
        lng: 12.3224079,
        name: "Scuola Grande dei Carmini",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 196,
        place_id: "ChIJ18gNTsmxfkcR6kOXLB8VecU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32241, 45.43366] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4335135,
        lng: 12.3222348,
        name: "Santa Maria dei Carmini - Santa Maria del Carmelo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 229,
        place_id: "ChIJ6eCgGMmxfkcRjUNlHjRSDfo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32223, 45.43351] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4342033,
        lng: 12.3276206,
        name: "Palazzo Moro Lin",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 11,
        place_id: "ChIJN7AIsM-xfkcRVlLP4Y14n8I",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32762, 45.4342] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4336977,
        lng: 12.331,
        name: "Santo Stefano, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 622,
        place_id: "ChIJqQrBztGxfkcRdvplq6vKs9U",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.331, 45.4337] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.433725,
        lng: 12.334177,
        name: "Bugno Art Gallery",
        types: [
          "art_gallery",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 21,
        place_id: "ChIJr24y6dCxfkcRhqExSgrZ9dE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33418, 45.43373] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4338467,
        lng: 12.33402,
        name: "San Fantin",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 63,
        place_id: "ChIJ3RP_69CxfkcR1aPgMnZxPYw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33402, 45.43385] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4342137,
        lng: 12.3369297,
        name: "Gondola Bacino Orseolo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 230,
        place_id: "ChIJUYR1RdexfkcRChoF57O4XZA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33693, 45.43421] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4337686,
        lng: 12.3385062,
        name: "Fondazione Musei Civici di Venezia",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 28,
        place_id: "ChIJNz8_Z8WxfkcRNSfblNwyzgo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33851, 45.43377] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4341602,
        lng: 12.3375252,
        name: "Olivetti Exhibition centre in Venice, Italy",
        types: [
          "museum",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 157,
        place_id: "ChIJ5R1tQtexfkcR8uQ3f51Qr-s",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33753, 45.43416] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.433413,
        lng: 12.3379391,
        name: "Procuratie Vecchie",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 25,
        place_id: "ChIJoQw6ZtexfkcR3-PKeMaAato",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33794, 45.43341] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4340359,
        lng: 12.3390331,
        name: "St Mark's Campanile",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 2647,
        place_id: "ChIJt92SstCxfkcR9D1UnQrkRq4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33903, 45.43404] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.433655,
        lng: 12.341016,
        name: "Ponte della Paglia",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 255,
        place_id: "ChIJxUM16dexfkcR_CV7BPwzJYw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34102, 45.43365] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4336359,
        lng: 12.3419214,
        name: "Gondole Stazio Danieli",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.5,
        user_ratings_total: 48,
        place_id: "ChIJnyxA4texfkcRuju0Y17hrKY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34192, 45.43364] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4338948,
        lng: 12.3433492,
        name: "Monument to Victor Emmanuel II",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 453,
        place_id: "ChIJmZtcDCiufkcRmViS3EgLd3Q",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34335, 45.43389] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4337804,
        lng: 12.3572324,
        name: "Vera da Pozzo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.8,
        user_ratings_total: 4,
        place_id: "ChIJL4GaizqufkcRAOqJ0fVctoE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.35723, 45.43378] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.435002,
        lng: 12.3168916,
        name: "Church of Santa Maria Maggiore",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 3.4,
        user_ratings_total: 18,
        place_id: "ChIJv3IKSCuwfkcRT5Hh5y-Pyic",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31689, 45.435] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.434438,
        lng: 12.325864,
        name: "Free Walk in Venice",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 21,
        place_id: "ChIJ9zNO6c6xfkcRclu64FL3sHY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32586, 45.43444] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4351628,
        lng: 12.3295145,
        name: "Fondaco Marcello",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.9,
        user_ratings_total: 28,
        place_id: "ChIJUSX378-xfkcRW1cgORPcZLg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32951, 45.43516] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4348585,
        lng: 12.3306277,
        name: "Organization for Conservation of Gondola",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 37,
        place_id: "ChIJcYo6btexfkcRZIvtShipPHA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33063, 45.43486] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4344919,
        lng: 12.3323642,
        name: "Campo Sant'Angelo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 476,
        place_id: "ChIJJU3QXNCxfkcRHldFYtvy6gc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33236, 45.43449] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4348543,
        lng: 12.334541,
        name: "Palazzo Contarini del Bovolo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 6372,
        place_id: "ChIJe05PnNCxfkcRIDheMhfPZfU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33454, 45.43485] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4346033,
        lng: 12.3363667,
        name: "Ponte Tron, Venice",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 15,
        place_id: "ChIJHcDkUtexfkcRmIByCoCJ-rg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33637, 45.4346] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4345305,
        lng: 12.3362784,
        name: "Venice Tours Srl",
        types: [
          "tourist_attraction",
          "travel_agency",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 145,
        place_id: "ChIJ7ze9UtexfkcRmYR7tyOG714",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33628, 45.43453] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4345703,
        lng: 12.3368719,
        name: "Church of St. Gall",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 8,
        place_id: "ChIJKfHJUtexfkcRRf9ZEOwYDfM",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33687, 45.43457] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4347389,
        lng: 12.3389394,
        name: "Torre dell'Orologio",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 827,
        place_id: "ChIJLbrmd9exfkcR4YVP0azgB4g",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33894, 45.43474] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4345606,
        lng: 12.3397124,
        name: "Saint Mark's Basilica",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 15247,
        place_id: "ChIJv2xSZNexfkcRBaKsgyfVEgo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33971, 45.43456] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4349833,
        lng: 12.3398341,
        name: "Diocese of Venice",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 39,
        place_id: "ChIJm0D_1MazfkcRK-nWbWqzNak",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33983, 45.43498] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4347794,
        lng: 12.3434712,
        name: "Chiesa di San Zaccaria",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 1185,
        place_id: "ChIJLYfu_CeufkcRqstxcaF2awA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34347, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.434645,
        lng: 12.3466571,
        name: "Campo Bandiera e Moro",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 361,
        place_id: "ChIJ4UxwOyaufkcR-b4hbeInEzs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34666, 45.43465] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4349482,
        lng: 12.3472202,
        name: "Cuore di mattoni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 5,
        place_id: "ChIJG2i7FSaufkcRIqLLfUHeBZk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34722, 45.43495] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4349494,
        lng: 12.3472199,
        name: "Sotoportego dei Preti",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 43,
        place_id: "ChIJ0f49PyaufkcR1cu9WmTvvM8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34722, 45.43495] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4347217,
        lng: 12.3488883,
        name: "San Martino, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 62,
        place_id: "ChIJGYzk4CWufkcRUEQ2j17QYBI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34889, 45.43472] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4348502,
        lng: 12.3499009,
        name: "Venetian Arsenal",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 6315,
        place_id: "ChIJ64TU6yWufkcRhn7M6ooFgHU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3499, 45.43485] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4347909,
        lng: 12.3498247,
        name: "Piraeus Lion",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.9,
        user_ratings_total: 46,
        place_id: "ChIJ55cIwiWufkcRj_llJG8ttSg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34982, 45.43479] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4348179,
        lng: 12.3495273,
        name: "Ponte del Purgatorio",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 22,
        place_id: "ChIJ7YOpwiWufkcRihN7eC7MlMs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34953, 45.43482] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4356967,
        lng: 12.3246925,
        name: "San Pantalon",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 817,
        place_id: "ChIJU5o6TM-xfkcRObpkzU6s92c",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32469, 45.4357] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4360046,
        lng: 12.3275886,
        name: "San Tomà",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 176,
        place_id: "ChIJl4EBgM-xfkcRu9nj7rOpUY4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32759, 45.436] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4353822,
        lng: 12.3279282,
        name: "Gondole San Tomà",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 8,
        place_id: "ChIJGSkthc-xfkcRTkwHs3bumyI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32793, 45.43538] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.435972,
        lng: 12.3293027,
        name: "Palazzo Pisani Moretta",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 127,
        place_id: "ChIJP3lyaMaxfkcRC9YBCbch9TY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3293, 45.43597] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4359263,
        lng: 12.3293622,
        name: "Palazzo Tiepolo Passi",
        types: [
          "tourist_attraction",
          "lodging",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 36,
        place_id: "ChIJhXymYcWxfkcRi0RRG5ksJNo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32936, 45.43593] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.435625,
        lng: 12.3323867,
        name: "San Beneto",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 8,
        place_id: "ChIJcwatE7ixfkcR0MUpaOIyKnk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33239, 45.43562] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4356958,
        lng: 12.3336567,
        name: "Chiesa di San Luca",
        types: [
          "place_of_worship",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.8,
        user_ratings_total: 8,
        place_id: "ChIJlSb3fdqxfkcR0SM1ZV2lPzw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33366, 45.4357] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4353342,
        lng: 12.3342631,
        name: "Pomnik Daniele Manin",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 5,
        place_id: "ChIJg9QnGc-xfkcRsCa5t-__89I",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33426, 45.43533] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4353498,
        lng: 12.3343556,
        name: "campo Manin",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 564,
        place_id: "ChIJVVWVd9qxfkcRFk0P16s5Bqs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33436, 45.43535] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4354977,
        lng: 12.3377549,
        name: "Chiesa di S. Croce degli Armeni",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 40,
        place_id: "ChIJH-7a5dmxfkcRmIWSN9a9_70",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33775, 45.4355] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4354435,
        lng: 12.3377182,
        name: "Sotoportego Dei Armeni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 2,
        place_id: "ChIJGwwfY66xfkcRCI0fR6Wp2zE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33772, 45.43544] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4356587,
        lng: 12.338867,
        name: "Campo San Zuilan",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJC94tWhWxfkcRBiBIJ6uAajA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33887, 45.43566] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4357806,
        lng: 12.3386827,
        name: "Chiesa di San Zulian",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 226,
        place_id: "ChIJZXB-wdmxfkcRRRjTHA2b1mQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33868, 45.43578] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4356664,
        lng: 12.3415602,
        name: "Church of San Giovanni Novo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 15,
        place_id: "ChIJnyKVP9ixfkcRsfQzxdUM0sI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34156, 45.43567] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4357668,
        lng: 12.3417204,
        name: "Calle a fianco la Chiesa",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJAaVkVtixfkcRN3Zohd6ObdE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34172, 45.43577] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4354311,
        lng: 12.3448054,
        name: "Church of Saint George 'dei Greci'",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 315,
        place_id: "ChIJMWEZlieufkcRlnyi8h7oh_g",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34481, 45.43543] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4357609,
        lng: 12.3443886,
        name: "Ponte dei Greci",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 45,
        place_id: "ChIJfdhAlieufkcRI09Pyc1U2Tc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34439, 45.43576] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.43572,
        lng: 12.3445441,
        name: "Istituto Ellenico di Studi Bizantini e Post Bizantini",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 20,
        place_id: "ChIJfXMXlieufkcRtXl6vtb-V0Q",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34454, 45.43572] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4353966,
        lng: 12.346443,
        name: "Chiesa di Sant'Antonin",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 32,
        place_id: "ChIJ6aucTiaufkcRV1pKwCvhemo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34644, 45.4354] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4367553,
        lng: 12.322356,
        name: "Palazzo Minotto",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJ-zo4q-SxfkcRUzWmcl5V8Ms",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32236, 45.43676] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4363568,
        lng: 12.3322494,
        name: "Grand Canal",
        types: [
          "tourist_attraction",
          "natural_feature",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.8,
        user_ratings_total: 3595,
        place_id: "ChIJfwNXbMOxfkcR3fggw8fOvfE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33225, 45.43636] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4368457,
        lng: 12.3361547,
        name: "campo San Salvador",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.2,
        user_ratings_total: 45,
        place_id: "ChIJyYSWItqxfkcRdTzITHohVF0",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33615, 45.43685] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4367669,
        lng: 12.3363838,
        name: "San Salvador, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 255,
        place_id: "ChIJw_DAkAGufkcRA4351X6V7Kc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33638, 45.43677] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4365455,
        lng: 12.3358312,
        name: "Lovo Bridge",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 185,
        place_id: "ChIJO7HEPtqxfkcRnBqccpFmFmY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33583, 45.43655] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4364333,
        lng: 12.3461604,
        name: "Chiesa di San Giovanni di Malta",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 19,
        place_id: "ChIJBQ1hACeufkcRYVa8e4Lm4yw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34616, 45.43643] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4361495,
        lng: 12.3459748,
        name: "Scuola di San Giorgio degli Schiavoni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 420,
        place_id: "ChIJGR0-TSaufkcRSCUHrUlwvDQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34597, 45.43615] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4363427,
        lng: 12.3471978,
        name: "Ugo Foscolo House",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.1,
        user_ratings_total: 28,
        place_id: "ChIJ8ye59yaufkcRo1RcKB0vmN8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3472, 45.43634] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.437444,
        lng: 12.3198296,
        name: "inGondola Venezia (Servizio Gondole Ferrovia/San Marcuola)",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 28,
        place_id: "ChIJ39sF8sexfkcR727ouFaYqcc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31983, 45.43744] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4376414,
        lng: 12.3215968,
        name: "Tolentini, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 379,
        place_id: "ChIJaZV9yMexfkcROrQOSlOz9AI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3216, 45.43764] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4375534,
        lng: 12.3275929,
        name: "Palazzo Zeno - Ca' Zen ai Frari",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 31,
        place_id: "ChIJNeFWosWxfkcRrmr5R8scpfU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32759, 45.43755] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4375663,
        lng: 12.32997,
        name: "Campo San Polo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 6747,
        place_id: "ChIJ5WbBPMWxfkcRrQPq2AKr8Ss",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32997, 45.43757] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4376228,
        lng: 12.3299432,
        name: "FREE WALK IN VENICE - original free tours",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 20,
        place_id: "ChIJ48vqPMWxfkcRvgEhXeEuNfg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32994, 45.43762] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4371937,
        lng: 12.3298295,
        name: "Rettoriale Church of San Polo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 58,
        place_id: "ChIJ-QW3RzqufkcRc20JhW1sDno",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32983, 45.43719] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4371836,
        lng: 12.3353887,
        name: "Palazzo Dolfin Manin",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 7,
        place_id: "ChIJBxK1TtqxfkcRTeToQCLHJwY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33539, 45.43718] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4375395,
        lng: 12.3365598,
        name: "Church of San Bartolomeo di Rialto",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 59,
        place_id: "ChIJ0Z-iy9uxfkcRYnKybavGDFE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33656, 45.43754] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.437735,
        lng: 12.3368462,
        name: "Monumento Storico a Carlo Goldoni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 73,
        place_id: "ChIJsdYh0NuxfkcRzlZIdMCa1tc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33685, 45.43774] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4369913,
        lng: 12.3379348,
        name: "Santa Maria della Fava",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 108,
        place_id: "ChIJ1fFBhNmxfkcR6lAo-Sbs82w",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33793, 45.43699] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4373236,
        lng: 12.3385075,
        name: "Hellenic Institute",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 2,
        place_id: "ChIJvTssuSeufkcRNQUDQ-5sNw8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33851, 45.43732] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4370659,
        lng: 12.3452603,
        name: "Church of San Lorenzo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.2,
        user_ratings_total: 121,
        place_id: "ChIJ7Z2vEieufkcRJFC8ZNaM6Rk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34526, 45.43707] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4383336,
        lng: 12.3161123,
        name: "Sant'Andrea della Zirada",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.0,
        user_ratings_total: 11,
        place_id: "ChIJe4NPN7ixfkcRb9GBRgfyLhs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31611, 45.43833] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4382983,
        lng: 12.3206545,
        name: "Giardini Papadopoli",
        types: [
          "park",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 1395,
        place_id: "ChIJRf6ilsexfkcR4Rj0vhtVtxI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32065, 45.4383] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4383338,
        lng: 12.3261008,
        name: "Scuola Grande di San Giovanni Evangelista",
        types: [
          "tourist_attraction",
          "museum",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 531,
        place_id: "ChIJrQ260cWxfkcRo0SkqBDHIio",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3261, 45.43833] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4385078,
        lng: 12.326688,
        name: "Palazzetto Bru Zane",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 100,
        place_id: "ChIJO1BhbMWxfkcRAkYwuC-_7jg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32669, 45.43851] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4384574,
        lng: 12.3265811,
        name: "Chorus - Associazione per le Chiese del Patriarcato di Venezia",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 4,
        place_id: "ChIJ-QW3RzqufkcR1IzG-Aht378",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32658, 45.43846] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4379975,
        lng: 12.3268917,
        name: "Campo San Stin",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 254,
        place_id: "ChIJ-Y0oyMWxfkcR7QIwLAEhQoc",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32689, 45.438] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4380161,
        lng: 12.329888,
        name: "Palazzo Soranzo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 19,
        place_id: "ChIJpwcaStixfkcRuZ-9z9F_CF8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32989, 45.43802] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4384133,
        lng: 12.3333934,
        name: "San Silvestro, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 79,
        place_id: "ChIJGyhu59qxfkcR5sK9E8dw7Rk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33339, 45.43841] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4379842,
        lng: 12.335898,
        name: "Rialto Bridge",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 98492,
        place_id: "ChIJOzqj-sexfkcRicyOKaERIHM",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3359, 45.43798] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4383672,
        lng: 12.3357027,
        name: "Palazzo dei Camerlenghi",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 35,
        place_id: "ChIJwztivNuxfkcR4PA_Ck3YPHM",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3357, 45.43837] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4381783,
        lng: 12.3354477,
        name: "Palazzo dei Dieci Savi",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 36,
        place_id: "ChIJYbMdsNuxfkcRE_vX4Ahgwao",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33545, 45.43818] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4386222,
        lng: 12.3377156,
        name: "Corte Morosina",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 1,
        place_id: "ChIJo477LaWxfkcRC2ZeS1Ldye8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33772, 45.43862] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.43857,
        lng: 12.34208,
        name: "Calle Vesier",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJIdFsK9OxfkcRKZUIOhLWuqU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34208, 45.43857] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4381335,
        lng: 12.3460277,
        name: "Santa Giustina, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 32,
        place_id: "ChIJdxptOieufkcRDfF-LEi3McU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34603, 45.43813] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4382987,
        lng: 12.3476511,
        name: "San Francesco della Vigna",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 337,
        place_id: "ChIJ70SH0SaufkcRXdjGiF6G7x0",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34765, 45.4383] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4394578,
        lng: 12.3239136,
        name: "Giardino di Palazzo Soranzo Cappello",
        types: [
          "tourist_attraction",
          "park",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 30,
        place_id: "ChIJQ6CA7saxfkcRJ2uQwNWvgpE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32391, 45.43946] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4394952,
        lng: 12.3290949,
        name: "Ponte del Modena",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 4,
        place_id: "ChIJu_AeYMSxfkcRZIMrUKrzUgA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32909, 45.4395] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4396137,
        lng: 12.3288419,
        name: "Ponte Storto",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 3,
        place_id: "ChIJSUcnYcSxfkcRTC1oc6YF_Fg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32884, 45.43961] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.43951,
        lng: 12.3285377,
        name: "Campo San Boldo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.7,
        user_ratings_total: 26,
        place_id: "ChIJO1B_Z8SxfkcRGbs0Upf9BNY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32854, 45.43951] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4391876,
        lng: 12.3351589,
        name: "Campo Bella Vienna",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 19,
        place_id: "ChIJq73bdduxfkcRKi7tx045ii8",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33516, 45.43919] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4391497,
        lng: 12.337245,
        name: "Church of St. Giovanni Crisostomo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.7,
        user_ratings_total: 111,
        place_id: "ChIJo9dw7tuxfkcRmKyd9jKPIG4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33724, 45.43915] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.438802,
        lng: 12.3378332,
        name: "Corte Seconda del Milion",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 18,
        place_id: "ChIJg6Xb49uxfkcRDTlJycfJn2E",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33783, 45.4388] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4395727,
        lng: 12.3393174,
        name: "Church of Santa Maria dei Miracoli",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 1476,
        place_id: "ChIJ62lRTdmxfkcRyvFRIr5As2c",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33932, 45.43957] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4393794,
        lng: 12.3417127,
        name: "Basilica dei Santi Giovanni e Paolo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 3660,
        place_id: "ChIJdQAAACSufkcRS74uquap8RY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34171, 45.43938] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4391891,
        lng: 12.3413774,
        name: "Equestrian statue of Bartolomeo Colleoni",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 100,
        place_id: "ChIJPeB51dixfkcR8HCEytOH_2M",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34138, 45.43919] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4392207,
        lng: 12.3412719,
        name: "Campo San Giovanni e Paolo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 162,
        place_id: "ChIJQVGVKtmxfkcRUi192OwsePU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34127, 45.43922] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4387897,
        lng: 12.3496445,
        name: "Procuratoria della Basilica di San Marco",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJt_1GUCGufkcR6vmBiAr6Phs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34964, 45.43879] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4403068,
        lng: 12.3224317,
        name: "San Simeone Piccolo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 567,
        place_id: "ChIJqQskPcexfkcRyRT6kHtYOwk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32243, 45.44031] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.440549,
        lng: 12.3243664,
        name: "Chiesa di San Simeone Profeta",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 72,
        place_id: "ChIJBUztzsaxfkcRpTrTen1PC2Y",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32437, 45.44055] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4400431,
        lng: 12.3303375,
        name: "Santa Maria Mater Domini",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 124,
        place_id: "ChIJcSRD9LixfkcRqo4-kPbu7Y0",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33034, 45.44004] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4397279,
        lng: 12.3320675,
        name: "Church of Saint Cassian",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 654,
        place_id: "ChIJm0-AscSxfkcREw_fJJAIe10",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33207, 45.43973] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.440213,
        lng: 12.332958,
        name: "Brandolin Morosini Palace",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 20,
        place_id: "ChIJUd7iqdyxfkcRqZKJfgClhF0",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33296, 45.44021] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4401261,
        lng: 12.3386557,
        name: "San Canciano",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 98,
        place_id: "ChIJTYdTAtyxfkcRRMocz2g_fEk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33866, 45.44013] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4397154,
        lng: 12.3385246,
        name: "Palazzo Bembo-Baldù",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJU5-A8DqxfkcRHLxDX9kAKtk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33852, 45.43972] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4398321,
        lng: 12.3400219,
        name: "Bridge of nostalgia (H. Pratt)",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJHe6H_ruxfkcRaG56aeelkBU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34002, 45.43983] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.441065,
        lng: 12.321051,
        name: "Estacion venecia santa lucia",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 7380,
        place_id: "ChIJzeUCUcexfkcRU71ymBY7tEw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32105, 45.44107] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.441159,
        lng: 12.3227238,
        name: "Scalzi Bridge",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 1775,
        place_id: "ChIJGUJXMsexfkcR13xbjnjvais",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32272, 45.44116] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4406661,
        lng: 12.3229306,
        name: "Palazzo Foscari Contarini",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 48,
        place_id: "ChIJw0cDMMexfkcRCjNRP0mAB_E",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32293, 45.44067] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4411358,
        lng: 12.3303567,
        name: "CHURCH OF SAN STAE",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 176,
        place_id: "ChIJefKabcOxfkcR8ouz38oD3jw",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33036, 45.44114] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4408951,
        lng: 12.3336031,
        name: "Palazzo Giusti",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.8,
        user_ratings_total: 4,
        place_id: "ChIJH9x-utyxfkcRvMvVui71jcg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3336, 45.4409] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4409853,
        lng: 12.3350313,
        name: "Santa Sofia, Venice",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 22,
        place_id: "ChIJLzNNM8OxfkcRYhmxIXNAnJU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33503, 45.44099] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4411923,
        lng: 12.3391199,
        name: "Calle Varisco: seconda calle più stretta del mondo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 8,
        place_id: "ChIJcxTVgyGxfkcRl18pdpk-Ofs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33912, 45.44119] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.440673,
        lng: 12.344736,
        name: "The Bragozzo local boats in Venice",
        types: [
          "tourist_attraction",
          "travel_agency",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.9,
        user_ratings_total: 39,
        place_id: "ChIJv01XY9-xfkcR7lq0NHAXABE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34474, 45.44067] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4418845,
        lng: 12.3208666,
        name: "Mama Isa: Cooking Classes Venice Italy | Cookery Courses",
        types: [
          "tourist_attraction",
          "restaurant",
          "food",
          "point_of_interest",
          "establishment",
        ],
        rating: 5.0,
        user_ratings_total: 162,
        place_id: "ChIJweZ4XMexfkcRCYsaBrJe07o",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32087, 45.44188] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.442256,
        lng: 12.32073,
        name: "Giardino Mistico",
        types: [
          "tourist_attraction",
          "park",
          "point_of_interest",
          "establishment",
        ],
        rating: 5.0,
        user_ratings_total: 3,
        place_id: "ChIJGU2YWb-xfkcRGwZmnD0kDI4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32073, 45.44226] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4422353,
        lng: 12.323581,
        name: "Rio Terà Lista di Spagna - Walking Street",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 3,
        place_id: "ChIJZ5m0NpmxfkcRgsGcdqbpR74",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32358, 45.44224] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4418319,
        lng: 12.3286198,
        name: "Natural History Museum",
        types: [
          "tourist_attraction",
          "museum",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 1580,
        place_id: "ChIJE_kaE7ixfkcRPiOl1I-ajYA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32862, 45.44183] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4419973,
        lng: 12.3291871,
        name: "Fondaco del Megio",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 3.7,
        user_ratings_total: 10,
        place_id: "ChIJRRPuvMOxfkcRUPyhI9tLfeQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32919, 45.442] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4416371,
        lng: 12.3324636,
        name: "Palazzetto Da Lezze",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 2,
        place_id: "ChIJlVINN8OxfkcRPYm5oaWfKus",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33246, 45.44164] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4418672,
        lng: 12.3333167,
        name: "Saint Felix Church",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 82,
        place_id: "ChIJtXRZbbixfkcRHAYa0rr6J9U",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33332, 45.44187] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4426551,
        lng: 12.3253544,
        name: "Chiesa di San Geremia",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 699,
        place_id: "ChIJP6pBEcGxfkcRLlDHutiqBEg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32535, 45.44266] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.44276,
        lng: 12.32689,
        name: "palazzo Querini Papozze",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 5.0,
        user_ratings_total: 3,
        place_id: "ChIJQZkbe8GxfkcRiPHK4-7qnSY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32689, 45.44276] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.442931,
        lng: 12.328688,
        name: "Chiesa di San Marcuola",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 194,
        place_id: "ChIJAZCTy8OxfkcROoeS5zo5gKE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32869, 45.44293] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4426234,
        lng: 12.3289861,
        name: "Ca' Gatti Casazza",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJ3Vdz5yKxfkcRx6_E0fAVkZs",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32899, 45.44262] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4426801,
        lng: 12.3297883,
        name: "Casino of Venice",
        types: [
          "casino",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 3.9,
        user_ratings_total: 1748,
        place_id: "ChIJwRQ9rsOxfkcRsPDoEbjDdfo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32979, 45.44268] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4430615,
        lng: 12.3311116,
        name: "Chiesa di Santa Maria Maddalena",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 66,
        place_id: "ChIJrQ0U_MKxfkcRqNiO95vJqWg",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33111, 45.44306] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4434568,
        lng: 12.3236839,
        name: "Parco Savorgnan",
        types: [
          "park",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.1,
        user_ratings_total: 254,
        place_id: "ChIJl_vB9sCxfkcRHnyYfVIOlwA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32368, 45.44346] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4440252,
        lng: 12.3241724,
        name: "Palazzo Savorgnan",
        types: [
          "tourist_attraction",
          "premise",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.9,
        user_ratings_total: 13,
        place_id: "ChIJVXQ7UMCxfkcRHue9EzWKlxI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32417, 45.44403] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.443665,
        lng: 12.3255482,
        name: "Guglie Bridge",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 3587,
        place_id: "ChIJq6pq9b-xfkcRft2zE8o_LsQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32555, 45.44367] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4434014,
        lng: 12.3268425,
        name: "San Leonardo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 16,
        place_id: "ChIJn0sencGxfkcRvfDXnaDsHvU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32684, 45.4434] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4436011,
        lng: 12.3268389,
        name: "Campo San Leonardo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJ96O1ik-xfkcRqKKIz_PtWZo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32684, 45.4436] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4440022,
        lng: 12.3285143,
        name: "Rio Terà S. Leonardo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJXfy9ujuxfkcRj8w15NfIR1Q",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32851, 45.444] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4440744,
        lng: 12.3293749,
        name: "Campiello L'anconeta",
        types: [
          "supermarket",
          "tourist_attraction",
          "grocery_or_supermarket",
          "food",
          "point_of_interest",
          "store",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 63,
        place_id: "ChIJN9P8PsKxfkcRock8W15v9QU",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32937, 45.44407] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4436275,
        lng: 12.3320278,
        name: "Palazzo Diedo",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.8,
        user_ratings_total: 5,
        place_id: "ChIJQSgh7MKxfkcRvVVnWKi5dS4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33203, 45.44363] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4438945,
        lng: 12.3351467,
        name: "Abbazia della Misericordia",
        types: [
          "church",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 86,
        place_id: "ChIJCwN-Rt2xfkcRAyu5XLK1l-4",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33515, 45.44389] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4433393,
        lng: 12.336359,
        name: "Chiesa di Santa Caterina",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.3,
        user_ratings_total: 35,
        place_id: "ChIJT3EYDd2xfkcRRvLVUh2KTuE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33636, 45.44334] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4448092,
        lng: 12.3230908,
        name: "Rio di Cannaregio",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 151,
        place_id: "ChIJ06ombcCxfkcR5bs9WZtwq7g",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32309, 45.44481] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4447861,
        lng: 12.3253106,
        name: "Old Matzah Bakery",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 0.0,
        user_ratings_total: 0,
        place_id: "ChIJm0i4EP6xfkcRNpvNVYgTm50",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32531, 45.44479] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4442416,
        lng: 12.325261,
        name: "Jewish Ghetto",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 1553,
        place_id: "ChIJ556-s8GxfkcRCOq3zrZae7U",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32526, 45.44424] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4454528,
        lng: 12.3130825,
        name: "Liberty Bridge",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.2,
        user_ratings_total: 379,
        place_id: "ChIJY3k8CL2xfkcROdoeiRMpEFo",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.31308, 45.44545] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4455709,
        lng: 12.3207247,
        name: "Tre Archi Bridge",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.5,
        user_ratings_total: 483,
        place_id: "ChIJKd6XrN-xfkcRz8sye3jWhSE",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32072, 45.44557] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4454378,
        lng: 12.3273133,
        name: "Chabad of Venice",
        types: [
          "synagogue",
          "tourist_attraction",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.8,
        user_ratings_total: 214,
        place_id: "ChIJDywV2cGxfkcRlAx60Zb7NNQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32731, 45.44544] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4453006,
        lng: 12.3323877,
        name: "Casa del Tintoretto",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.6,
        user_ratings_total: 35,
        place_id: "ChIJi5elKOixfkcRWHTsXVEAQqQ",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33239, 45.4453] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4461197,
        lng: 12.3250445,
        name: "Chiesa di San Girolamo",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.4,
        user_ratings_total: 21,
        place_id: "ChIJXTpTg-qxfkcRH_rs6eulJsY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32504, 45.44612] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4464968,
        lng: 12.3326017,
        name: "Church of Madonna dell'Orto",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 936,
        place_id: "ChIJC14hSuixfkcRwjjuhGsgqkA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.3326, 45.4465] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.446317,
        lng: 12.3354149,
        name: "Casino Degli Spiriti",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.3,
        user_ratings_total: 24,
        place_id: "ChIJXywb2eexfkcRzDU7daShDOk",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.33541, 45.44632] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4466129,
        lng: 12.3458427,
        name: "San Michele Cemetery",
        types: [
          "cemetery",
          "tourist_attraction",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.6,
        user_ratings_total: 231,
        place_id: "ChIJI-yLUMexfkcRnbup5tlG6sI",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34584, 45.44661] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4468052,
        lng: 12.3483625,
        name: "Grave of Igor Stravinsky",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.4,
        user_ratings_total: 77,
        place_id: "ChIJEyi3EB6ufkcRgm4VUnpW1IA",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.34836, 45.44681] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4476368,
        lng: 12.3234667,
        name: "Venice On Board",
        types: ["tourist_attraction", "point_of_interest", "establishment"],
        rating: 4.9,
        user_ratings_total: 65,
        place_id: "ChIJt-erzeqxfkcR70F8Lo3ZvvY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32347, 45.44764] },
    },
    {
      type: "Feature",
      properties: {
        lat: 45.4474748,
        lng: 12.3290537,
        name: "Chiesa Parrocchiale di Sant'Alvise (San Ludovico Vescovo)",
        types: [
          "tourist_attraction",
          "church",
          "place_of_worship",
          "point_of_interest",
          "establishment",
        ],
        rating: 4.5,
        user_ratings_total: 185,
        place_id: "ChIJRVThK-qxfkcRMQoXEJqlArY",
        price_level: 0,
      },
      geometry: { type: "Point", coordinates: [12.32905, 45.44747] },
    },
  ],
};
